import m from "../../geodata/es2015/armeniaHigh";
window.am4geodata_armeniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/armeniaHigh.js
// module id = null
// module chunks = 